import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class UserService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getUsers(): Observable<any> {
        return super.get("/api/user").pipe(
            map((res: any) => res)
        );
    }

    getUser(id: string): Observable<any> {
        return super.get(`/api/user/${id}`).pipe(
            map((res: any) => res)
        );
    }

    createUser(user: any): Observable<any> {
        return super.post("/api/user", user).pipe(
            map((res: any) => res)
        );
    }

    updateUser(user: any): Observable<any> {
        return super.put("/api/user/", user).pipe(
            map((res: any) => res)
        );
    }

    // Add missing methods used by components
    create(user: any): Observable<any> {
        return this.createUser(user);
    }

    update(user: any): Observable<any> {
        return this.updateUser(user);
    }

    sendInvitation(user: any): Observable<any> {
        return super.post("/api/invitation", user).pipe(
            map((res: any) => res)
        );
    }

    getPagedUsers(pageNumber: number, pageSize: number, searchTerm?: string): Observable<any> {
        let url = `/api/user/getPagedResult/${pageNumber}/${pageSize}?searchTerm=${searchTerm}`;
        // if (searchTerm) {
        //     url += `&search=${encodeURIComponent(searchTerm)}`;
        // }
        return super.get(url).pipe(
            map((res: any) => res)
        );
    }

    getUsersCount(searchTerm: string): Observable<any> {
        let url = `/api/user/count?searchTerm=${searchTerm}`;
        // if (searchTerm) {
        //     url += `?search=${encodeURIComponent(searchTerm)}`;
        // }
        return super.get(url).pipe(
            map((res: any) => res)
        );
    }

    getRoles(): Observable<any> {
        return super.get("/api/role").pipe(
            map((res: any) => res)
        );
    }
}

